import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localTimeDate',
  standalone: false
})
export class LocalTimeDatePipe implements PipeTransform {

  transform(date: string): string {
    let toDay = new Date().toLocaleDateString();
    let insertDate = new Date(date).toLocaleDateString();

    let day = ""
    let time = new Date(date).toLocaleTimeString();
    time = time.split(':').slice(0, 2).join(':');
    day = insertDate === toDay ? 'Today' : insertDate;
    return `${day} ${time}`;
  }

}
